import { useCallback, useRef, useState, type RefObject } from 'react';

export const useSuggestionsFeedback = (): {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	triggerRef: RefObject<HTMLButtonElement>;
} => {
	const [isOpen, setIsOpen] = useState(false);
	const triggerRef = useRef<HTMLButtonElement>(null);
	const open = useCallback(() => setIsOpen(true), []);
	const close = useCallback(() => {
		setIsOpen(false);
		triggerRef.current?.focus();
	}, []);

	return { isOpen, open, close, triggerRef };
};
